import { useTranslation } from 'react-i18next';
const HeroSection = ({ ruta }) => {

    const { t } = useTranslation();

    var imagen = ruta + "/blog/cabecera/cabecera.jpg";


    return (
        <div className="cc-header-img">
            <div className="c-header-img">
                <img className="o-loader" hidden="" />
                <img alt="" className="" src={imagen} />
                <h1 >{t("Noticias")}</h1>
            </div>
        </div>
    );
}

export default HeroSection
